"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../../utils/system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableFooter = (0, _system["default"])('tfoot')({
  label: 'TableFooter'
}, (0, _css["default"])({
  boxSizing: 'border-box',
  display: 'table-row-group',
  verticalAlign: 'middle',
  borderColor: 'inherit',
  fontFamily: 'body',
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: 'base'
}));
TableFooter.displayName = 'TableFooter';
var _default = TableFooter;
exports["default"] = _default;

//# sourceMappingURL=TableFooter.js.map